export enum ApplicationError {
	generalFailure = 'Došlo k chybě, prosím obnovte stránku a akci opakujte.',
	connectionFailure = 'Chyba při komunikaci se serverem. Zkuste to prosím znovu.',
	resourceNotFound = 'Stránka neexistuje.',
}
